module.exports = __webpack_public_path__ + "img/hotel_en_oaxaca-arte.a0e64972.svg";